import { GHLLanguageKeys as e } from "./ghl-ui.es285.js";
import o from "./ghl-ui.es803.js";
const r = {
  name: e.german,
  locale: o
};
export {
  r as date_de
};
